import z from 'zod';

import { Dictionary } from '@/core/lib/dict';

export const getSubmitArtworkSchema = (dictionary: Dictionary) => {
  return z.object({
    artist_name: z.string().min(2, {
      message: dictionary.forms.firstname + ' ' + dictionary.errors.required,
    }),
    artist_family: z.string().min(2, {
      message: dictionary.forms.lastname + ' ' + dictionary.errors.required,
    }),
    artist_phone: z
      .string()
      .min(1, {
        message: dictionary.forms.mobile + ' ' + dictionary.errors.required,
      })
      .regex(/^\d+$/, {
        message: dictionary.forms.mobile + ' ' + dictionary.errors.number,
      }),
    title: z.string().min(1, {
      message: dictionary.forms.artworkName + ' ' + dictionary.errors.required,
    }),
    dimensions: z.string().optional(),
    price: z.string().optional(),
    technique: z.string().optional(),
    description: z.string().optional(),
    artist_email: z
      .string()
      .email({
        message: dictionary.errors.invalidEmail,
      })
      .optional(),
    artist_instagram: z.string().optional(),
    recaptcha_token: z.string().min(1, {
      message: dictionary.forms.captcha,
    }),
  });
};

export type SubmitArtworkFormData = z.infer<
  ReturnType<typeof getSubmitArtworkSchema>
>;
